import { ChangeDetectorRef, Component, EventEmitter, Output, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { JourneyType, FlightType, FlightSearchRequest } from '../../../../shared/models/search-bar';
import { SearchBarService } from '../../services/search.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BsDaterangepickerDirective, BsDatepickerDirective, BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { GeolocationService } from '../../../../shared/services/geolocation.service';
import { DataService } from '../../../../shared/data/data.service';

@Component({
  selector: 'app-flight-search',
  standalone: false,
  templateUrl: './flight-search.component.html',
  styleUrl: './flight-search.component.scss'
})



export class FlightSearchComponent implements OnInit, OnDestroy {
   
dateRange: Date[] = [];

isLoading: boolean = false;

@ViewChild('originPicker') originPicker: any;

@ViewChild('destinationPicker') destinationPicker: any;

@ViewChild('dateRangePicker', { static: false })
dateRangePicker!: BsDaterangepickerDirective;

@ViewChild('singleDatePicker', { static: false })
singleDatePicker!: BsDatepickerDirective;

flightForm!: FormGroup;

  swapAirports() {
    const arr = this.flightForm?.get('OriginDestinationInfo') as FormArray;
    if (arr && arr.length > 0) {
      const group = arr.at(0) as FormGroup;
      const origin = group.get('airportOriginCode')?.value;
      const dest = group.get('airportDestinationCode')?.value;
      group.get('airportOriginCode')?.setValue(dest);
      group.get('airportDestinationCode')?.setValue(origin);
      this._cdr?.detectChanges();
      // Clear search input in both pickers
      this.originPicker?.clearSearchInput();
      this.destinationPicker?.clearSearchInput();
    }
  }

  @Output() search:EventEmitter<string> = new EventEmitter<string>();

  bsValue=new Date();
  time: Date | null = null;
  // flightForm!: FormGroup;

  get journeyTypeEnum(): typeof JourneyType {
    return JourneyType;
  }

  get flightType(): typeof FlightType {
    return FlightType;
  }

  private readonly allowedFlightSearchURLs = [
    'home',
    'flight-list',
    'flight-details',
  ]

  constructor(
    private readonly _fb: FormBuilder,
    private readonly searchBarService: SearchBarService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  private readonly _cdr: ChangeDetectorRef,
  private readonly geo: GeolocationService,
  private readonly dataService: DataService
  ) {
    const defaultTime = new Date();
    defaultTime.setHours(10, 30, 0, 0); // Set hours, minutes, seconds, milliseconds
    this.time = defaultTime;

    // Subscribe to loading state for spinner
    this.searchBarService.isLoading$.subscribe((loading: boolean) => {
      this.isLoading = loading;
      setTimeout(() => {
        this._cdr.markForCheck();
      });
    });
  }

  // Configure date picker with mobile optimization
bsConfig: Partial<BsDatepickerConfig> = {
  dateInputFormat: 'DD/MM/YYYY',
  containerClass: 'theme-default mobile-responsive',
  showWeekNumbers: false,
  adaptivePosition: true,
  isAnimated: true,
  displayMonths: 1,
  minDate: new Date()
};


  // Range picker configuration with mobile optimization
bsRangeConfig: Partial<BsDaterangepickerConfig> = {
  dateInputFormat: 'DD/MM/YYYY',
  containerClass: 'theme-default mobile-responsive',
  showWeekNumbers: false,
  adaptivePosition: true,
  isAnimated: true,
  rangeInputFormat: 'DD/MM/YYYY',
  displayMonths: 2,
  minDate: new Date()
};

  // Mobile travellers overlay state
  mobileTravellersOpen: boolean = false;

  private _bodyScrollLock?: {
    scrollY: number;
    position: string;
    top: string;
    left: string;
    right: string;
    width: string;
    overflow: string;
  };

  private lockBodyScroll(): void {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    if (this._bodyScrollLock) return;

    const body = document.body;
    this._bodyScrollLock = {
      scrollY: window.scrollY || window.pageYOffset || 0,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
    };

    body.classList.add('travellers-open');
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${this._bodyScrollLock.scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  }

  private unlockBodyScroll(): void {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    if (!this._bodyScrollLock) return;

    const body = document.body;
    const { scrollY, position, top, left, right, width, overflow } = this._bodyScrollLock;

    body.style.position = position;
    body.style.top = top;
    body.style.left = left;
    body.style.right = right;
    body.style.width = width;
    body.style.overflow = overflow;
    body.classList.remove('travellers-open');

    this._bodyScrollLock = undefined;
    window.scrollTo(0, scrollY);
  }

  ngOnInit(): void {
  this.flightForm = this._fb.group({
      OriginDestinationInfo: this._fb.array([]),
      // directFlight: [FlightDirection.DIRECT, Validators.required],
      requiredCurrency: ['USD', Validators.required],
      language: ['en', Validators.required],
      class: [FlightType.ECONOMY, Validators.required],
      adults: [1, [Validators.required, Validators.min(1),Validators.max(9)]],
      // children: max 6
      childs: [0, [Validators.min(0), Validators.max(6)]],
      // infants: max 3 (additional cross-rule below: infants <= adults)
      infants: [0, [Validators.min(0), Validators.max(3)]],
      journeyType: [JourneyType.ROUND_TRIP, Validators.required],
    }, { validators: [this.passengerRulesValidator.bind(this)] });
    // suppress autosave until we've finished initial patching
    this._suppressAutoSave = true;

    // Try to prefill nearest airport for origin if empty
    this.prefillNearestAirportIfEmpty();

    // Patch currency and language from localStorage if available
    this.getLocalStorageValues();
    (this.flightForm.get('OriginDestinationInfo') as FormArray).push(this.originDestinationInfoForm);
     this.validateAndFixDates();
    // Determine initial form value: prefer query params, then service cache, then localStorage
    let initialValue: any = null;
    const qp = this.route.snapshot.queryParams;
    if (qp && Object.keys(qp).length > 0) {
      initialValue = this.searchBarService.fromQueryParams(qp);
    } else {
      initialValue = this.searchBarService.flightSearchRequest;
      if (!initialValue) {
        const raw = localStorage.getItem('flightSearchRequest');
        if (raw) {
          try {
            initialValue = JSON.parse(raw) as FlightSearchRequest;
            this.searchBarService.changeFlightSearchRequest(initialValue as FlightSearchRequest);
          } catch (e) {
            console.warn('Invalid flightSearchRequest in localStorage', e);
            initialValue = null;
          }
        }
      }
      if (initialValue) {
        initialValue = this.searchBarService.fromQueryParams(initialValue);
      }
    }

    // If we have an initial value, patch the form and populate arrays
    if (initialValue) {




this.flightForm.patchValue(initialValue);

if (initialValue.OriginDestinationInfo) {

  const arr = this.flightForm.get('OriginDestinationInfo') as FormArray;

  arr.clear();

  initialValue.OriginDestinationInfo.forEach((od: any) => 
    arr.push(this._fb.group(od))
  );

}

// ✅ NOW run validation AFTER form is ready
this.validateAndFixDates();

      this.searchBarService.changeFlightSearchRequest(initialValue as FlightSearchRequest);
      this._cdr.detectChanges();
      this.prefillNearestAirportIfEmpty();

      if (this.router.url.includes('flight-list')) {
        const querystring = this.searchBarService.toQueryString(initialValue);
        this.router.navigateByUrl('/flight/flight-list?' + querystring);
      }
    }

    // Auto-clamp pax values to satisfy business rules during input
    this.flightForm.get('adults')?.valueChanges.subscribe(() => this.enforcePassengerRules());
    this.flightForm.get('childs')?.valueChanges.subscribe(() => this.enforcePassengerRules());
    this.flightForm.get('infants')?.valueChanges.subscribe(() => this.enforcePassengerRules());

    // Auto-save form to localStorage and service after user edits (debounced)
    // enable autosave now that initial patching is complete
    this._suppressAutoSave = false;
    this._autoSaveSub = this.flightForm.valueChanges.pipe(debounceTime(400)).subscribe(val => {
      if (this._suppressAutoSave) return;
      try {
        const snapshot = JSON.parse(JSON.stringify(val));
        if (snapshot) {
          localStorage.setItem('flightSearchRequest', JSON.stringify(snapshot));
          this.searchBarService.changeFlightSearchRequest(snapshot as FlightSearchRequest);
        }
      } catch (e) {
        console.warn('Failed to autosave flight form', e);
      }
    });

    // this.parentFormGroupForDestinationInfo.get('departureDate')?.valueChanges.subscribe(depDate => {
    //   this.updateReturnDate(depDate);
    // });

    this.flightForm.get('journeyType')?.valueChanges.subscribe(trip => {
      const returnCtrl = this.parentFormGroupForDestinationInfo.get('returnDate');
      const departureCtrl = this.parentFormGroupForDestinationInfo.get('departureDate');
      if (trip === JourneyType.ROUND_TRIP) {
        returnCtrl?.setValidators([Validators.required]);
      } else {
        returnCtrl?.clearValidators();
      }

      this.updateReturnDate(departureCtrl?.value);
      returnCtrl?.updateValueAndValidity();
    });

    // If we're on the flight-list page, trigger the flight search API once on load
    if (this.isAllowedFlightSearchUrl) {
      // Call the search API with current form/state (service holds the latest request)
      try {
        this.searchBarService.getFlightSearchData();
      } catch (e) {
        console.warn('Failed to auto-trigger flight search on init', e);
      }
    }

    // NOTE: We intentionally do NOT persist or trigger searches on every form change here.
    // State will be saved and search executed only when the user explicitly clicks Search.
  }

  // --- Passenger Rules ---
  // Root-level validator: infants <= adults, adults + children <= 9
  private passengerRulesValidator(group: AbstractControl): ValidationErrors | null {
    const adults = Number(group.get('adults')?.value || 0);
    const children = Number(group.get('childs')?.value || 0);
    const infants = Number(group.get('infants')?.value || 0);

    const errors: ValidationErrors = {};
    if (infants > adults) errors['infantsExceedAdults'] = true;
    if (adults + children > 9) errors['adultsChildrenExceed'] = true;

    // Per-field maxima already enforced by control validators, but keep here if values set programmatically
    if (children > 6) errors['childrenMax'] = true;
    if (infants > 3) errors['infantsMax'] = true;

    // Validate airport codes
    const arr = group.get('OriginDestinationInfo') as FormArray;
    if (!arr || arr.length === 0) {
      errors['originDestinationInfoMissing'] = true;
    } else {
      const odGroup = arr.at(0) as FormGroup;
      const origin = odGroup.get('airportOriginCode')?.value;
      const dest = odGroup.get('airportDestinationCode')?.value;
      if (!origin || origin.trim() === '') {
        errors['airportOriginCodeMissing'] = true;
        odGroup.get('airportOriginCode')?.markAsTouched();
      }
      if (!dest || dest.trim() === '') {
        errors['airportDestinationCodeMissing'] = true;
        odGroup.get('airportDestinationCode')?.markAsTouched();
      }
    }

    return Object.keys(errors).length ? errors : null;
  }

  private enforcePassengerRules(): void {
    const aCtrl = this.flightForm.get('adults');
    const cCtrl = this.flightForm.get('childs');
    const iCtrl = this.flightForm.get('infants');
    if (!aCtrl || !cCtrl || !iCtrl) return;

    let a = Number(aCtrl.value || 0);
    let c = Number(cCtrl.value || 0);
    let i = Number(iCtrl.value || 0);

    // Clamp individual maxima
    c = Math.min(Math.max(0, c), 6);
    i = Math.min(Math.max(0, i), 3);

    // Infants cannot exceed adults
    i = Math.min(i, a);

    // Adults + Children cannot exceed 9 (prefer preserving adults, clamp children)
    const maxChildrenAllowed = Math.max(0, 9 - a);
    c = Math.min(c, maxChildrenAllowed);

    // Apply back if changes
    const changes: any = {};
    if (c !== Number(cCtrl.value)) changes.childs = c;
    if (i !== Number(iCtrl.value)) changes.infants = i;
    if (Object.keys(changes).length) {
      this.flightForm.patchValue(changes, { emitEvent: false });
    }

    // Recompute validity
    this.flightForm.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  // Explicit user action: set origin to nearest airport and persist
  useNearestOrigin(): void {
    const arr = this.flightForm?.get('OriginDestinationInfo') as FormArray;
    if (!arr || arr.length === 0) return;
    const group = arr.at(0) as FormGroup;
    this.geo.getCoords().subscribe(coords => {
      if (!coords) return;
      this.dataService.getNearestAirport(coords.lat, coords.lon).subscribe(nearest => {
        if (!nearest) return;
        group.get('airportOriginCode')?.setValue(nearest.code);
        // Do not persist automatically here; only update form control. Persist on explicit Search.
        // ensure the picker reflects immediately
        this._cdr.detectChanges();
        this.originPicker?.clearSearchInput();
      });
    });
  }

  private prefillNearestAirportIfEmpty(): void {
    const arr = this.flightForm?.get('OriginDestinationInfo') as FormArray;
    if (!arr || arr.length === 0) return;
    const group = arr.at(0) as FormGroup;
    const origin = group.get('airportOriginCode')?.value;
    if (origin) return;
    this.geo.getCoords().subscribe(coords => {
      if (!coords) return;
      this.dataService.getNearestAirport(coords.lat, coords.lon).subscribe(nearest => {
        if (!nearest) return;
  group.get('airportOriginCode')?.setValue(nearest.code);
  // Do not persist automatically here; only update form control. Persist on explicit Search.
      });
    });
  }

  private getLocalStorageValues(){
     const selectedCountryInfo = localStorage.getItem('selectedCountryInfo');
    if (selectedCountryInfo) {
      try {
        const info = JSON.parse(selectedCountryInfo);
        if (info.currency) {
          this.flightForm.get('requiredCurrency')?.setValue(info.currency);
        }
        if (info.carLanguage) {
          this.flightForm.get('language')?.setValue(info.carLanguage);
        }
      } catch (e) {
        console.warn('Invalid JSON in flight-search selectedCountryInfo:', e);
      }
    }
  }






private updateReturnDate(depDate: Date | string | null) {

  const group = this.parentFormGroupForDestinationInfo;
  const returnCtrl = group.get('returnDate');

  if (!depDate || !returnCtrl) return;

  let dep = typeof depDate === 'string'
    ? this.parseJsonDate(depDate)
    : depDate;

  if (!dep) return;

  let retValue = returnCtrl.value;

  let ret = typeof retValue === 'string'
    ? this.parseJsonDate(retValue)
    : retValue;

  // 🚨 CRITICAL FIX
  // Only update return if it is EMPTY
  // DO NOT override valid user selection

  if (!ret) {

    const newReturn = new Date(dep);
    newReturn.setDate(dep.getDate() + 1);

    returnCtrl.patchValue(
      this.formatDateForJson(newReturn),
      { emitEvent:false }
    );

    return;
  }

  // 🚨 DO NOT TOUCH if user selected valid return
}







get originDestinationInfoForm() {

  const dep = this.getDatePlusMonths(new Date(), 1);

  const ret = new Date(dep);
  ret.setDate(dep.getDate() + 1);

  // ✅ VERY IMPORTANT
  this.dateRange = [dep, ret];

  const form = new FormGroup({
    departureDate: new FormControl(
      this.formatDateForJson(dep),
      Validators.required
    ),

    returnDate: new FormControl(
      this.formatDateForJson(ret)
    ),

    airportOriginCode: new FormControl('', Validators.required),

    airportDestinationCode: new FormControl('', Validators.required)

  });

  return form;
}

  private getNextDate(date: Date, days: number = 1): Date {
    const next = new Date(date);
    next.setDate(date.getDate() + days);
    return next;
  }

  private getDatePlusMonths(date: Date, months: number = 1): Date {
    const d = new Date(date);
    const day = d.getDate();
    d.setMonth(d.getMonth() + months);
    // If month overflowed (e.g., Jan 31 -> Mar 03), snap to last day of previous month
    if (d.getDate() !== day) {
      d.setDate(0);
    }
    return d;
  }

  // Handle date range change from ngx-bootstrap date range picker (Round Trip)
  onDateRangeChange(dateRange: (Date | undefined)[] | undefined) {
    if (dateRange && dateRange.length >= 2) {
      const startDate = dateRange[0];
      const endDate = dateRange[1];

      if (startDate && endDate) {
        // Update form controls with dates in YYYY-MM-DD format
        this.parentFormGroupForDestinationInfo.patchValue({
          departureDate: this.formatDateForJson(startDate),
          returnDate: this.formatDateForJson(endDate)
        });
      }
    } else if (dateRange && dateRange.length === 1) {
      // Only start date selected, clear end date
      const startDate = dateRange[0];
      if (startDate) {
        this.parentFormGroupForDestinationInfo.patchValue({
          departureDate: this.formatDateForJson(startDate),
          returnDate: null
        });
      }
    } else {
      // Clear both dates if range is cleared or undefined
      this.parentFormGroupForDestinationInfo.patchValue({
        departureDate: null,
        returnDate: null
      });
    }
  }

  // Handle single date change for OneWay journey
  onSingleDateChange(date: Date | undefined) {
    if (date) {
      const formattedDate = this.formatDateForJson(date);
      this.parentFormGroupForDestinationInfo.patchValue({
        departureDate: formattedDate,
        returnDate: formattedDate // Set return date same as departure for OneWay
      });
    }
  }

  // Format date to YYYY-MM-DD for JSON/form data
  private formatDateForJson(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  // Parse date string back to Date object for date picker
  private parseJsonDate(dateString: string): Date | null {
    if (!dateString) return null;
    // Handle both YYYY-MM-DD and DD-MM-YYYY formats
    if (dateString.includes('-')) {
      const parts = dateString.split('-');
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          // YYYY-MM-DD format
          return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          // DD-MM-YYYY format
          return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
        }
      }
    }
    return new Date(dateString);
  }

private validateAndFixDates(): void {

  const group = this.parentFormGroupForDestinationInfo;
  if (!group) return;

  const today = new Date();
  today.setHours(0,0,0,0);

  let dep = this.parseJsonDate(group.get('departureDate')?.value);
  let ret = this.parseJsonDate(group.get('returnDate')?.value);

  if (!dep || dep < today) {

    dep = new Date(today);

    group.patchValue({
      departureDate: this.formatDateForJson(dep)
    }, { emitEvent:false });

  }

  if (!ret || ret <= dep) {

    ret = new Date(dep);
    ret.setDate(dep.getDate() + 1);

    group.patchValue({
      returnDate: this.formatDateForJson(ret)
    }, { emitEvent:false });

  }

  // sync with datepicker
  this.dateRange = [dep, ret];

}








onDateRangeSelected(range: (Date | undefined)[] | undefined): void {

  if (!range || range.length < 2) return;

  const dep = range[0];
  const ret = range[1];

  if (!dep || !ret) return;

  this.parentFormGroupForDestinationInfo.patchValue({

    departureDate: this.formatDateForJson(dep),
    returnDate: this.formatDateForJson(ret)

  }, { emitEvent:false });

}


  // FIX return only if:
  // 1 return missing
  // 2 return in past
  
  // update localStorage only if auto-correct happened


  // Get formatted date for display in the input fields (DD-MM-YYYY)
  getFormattedDate(fieldName: 'departureDate' | 'returnDate'): string {
    const dateValue = this.parentFormGroupForDestinationInfo?.get(fieldName)?.value;
    if (dateValue) {
      let date: Date;
      if (typeof dateValue === 'string') {
        const parsedDate = this.parseJsonDate(dateValue);
        if (!parsedDate) return '';
        date = parsedDate;
      } else if (dateValue instanceof Date) {
        date = dateValue;
      } else {
        return '';
      }

      // Format to DD-MM-YYYY for display
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return '';
  }

  // Get date label (day name) for display
  getDateLabel(fieldName: 'departureDate' | 'returnDate'): string {
    const dateValue = this.parentFormGroupForDestinationInfo?.get(fieldName)?.value;
    if (dateValue) {
      let date: Date;
      if (typeof dateValue === 'string') {
        const parsedDate = this.parseJsonDate(dateValue);
        if (!parsedDate || isNaN(parsedDate.getTime())) {
          return fieldName === 'departureDate' ? 'Select departure date' : 'Select return date';
        }
        date = parsedDate;
      } else if (dateValue instanceof Date) {
        date = dateValue;
      } else {
        return fieldName === 'departureDate' ? 'Select departure date' : 'Select return date';
      }

      if (!isNaN(date.getTime())) {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[date.getDay()];
      }
    }
    return fieldName === 'departureDate' ? 'Select departure date' : 'Select return date';
  }

  // Open the appropriate date picker based on journey type
  openDatePicker(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Add body class for mobile scroll prevention
    if (window.innerWidth <= 767) {
      document.body.classList.add('datepicker-open');
    }

    if (this.journeyType === JourneyType.ROUND_TRIP) {
      // Use date range picker for round trip
      if (this.dateRangePicker) {
        this.dateRangePicker.show();
      }
    } else if (this.singleDatePicker) {
      // Use single date picker for one-way
      this.singleDatePicker.show();
    }

    // Add mobile overlay close functionality
    setTimeout(() => {
      this.addMobileCloseHandler();
    }, 50); // Reduced timeout for faster execution

    // Force mobile styles more aggressively
    if (window.innerWidth <= 767) {
      setTimeout(() => {
        this.forceMobileStylesAggressively();
      }, 10);
    }
  }

  // Toggle travellers panel: on mobile show overlay, otherwise allow dropdown
  onTravellerToggle(event?: Event): void {
    try {
      if (window.innerWidth <= 767) {
        // Prevent bootstrap dropdown from opening
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        this.mobileTravellersOpen = true;
        // prevent body scroll while overlay open
        this.lockBodyScroll();
      }
      // else let bootstrap handle dropdown behavior
    } catch (e) {
      console.warn('Failed to toggle mobile travellers overlay', e);
    }
  }

  closeMobileTravellers(): void {
    this.mobileTravellersOpen = false;
    this.unlockBodyScroll();
  }

  // Add click handler for mobile overlay close
  private addMobileCloseHandler(): void {
    const datePickerContainer = document.querySelector('.bs-datepicker-container');
    if (datePickerContainer && window.innerWidth <= 767) {
      const overlay = datePickerContainer as HTMLElement;

      // Force override inline styles applied by ngx-bootstrap on mobile
      this.forceMobileStyles(overlay);

      const handleOverlayClick = (event: Event) => {
        const target = event.target as HTMLElement;

        // Close if clicking on the overlay background (not on the datepicker itself)
        if (target === overlay || target.classList.contains('bs-datepicker-container')) {
          this.closeDatePicker();
          overlay.removeEventListener('click', handleOverlayClick);
          document.removeEventListener('keydown', handleEscapeKey);
        }

        // Close if clicking on the pseudo-element close button
        if (target === overlay) {
          const rect = overlay.getBoundingClientRect();
          const clickX = (event as MouseEvent).clientX - rect.left;
          const clickY = (event as MouseEvent).clientY - rect.top;

          // Check if click is in the close button area (top-right corner)
          if (clickX > rect.width - 70 && clickY < 70) {
            this.closeDatePicker();
            overlay.removeEventListener('click', handleOverlayClick);
            document.removeEventListener('keydown', handleEscapeKey);
          }
        }
      };

      // Also listen for escape key
      const handleEscapeKey = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          this.closeDatePicker();
          overlay.removeEventListener('click', handleOverlayClick);
          document.removeEventListener('keydown', handleEscapeKey);
        }
      };

      overlay.addEventListener('click', handleOverlayClick);
      document.addEventListener('keydown', handleEscapeKey);
    }
  }

  // Force mobile styles to override ngx-bootstrap inline styles
  private forceMobileStyles(container: HTMLElement): void {
    if (window.innerWidth <= 767) {
      // Force override the inline styles
      container.style.setProperty('position', 'fixed', 'important');
      container.style.setProperty('top', '0px', 'important');
      container.style.setProperty('left', '0px', 'important');
      container.style.setProperty('right', '0px', 'important');
      container.style.setProperty('bottom', '0px', 'important');
      container.style.setProperty('width', 'max-content', 'important');
      container.style.setProperty('height', 'max-content', 'important');
      container.style.setProperty('transform', 'none', 'important');
      container.style.setProperty('will-change', 'auto', 'important');
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('align-items', 'center', 'important');
      container.style.setProperty('justify-content', 'center', 'important');
      container.style.setProperty('background', 'white', 'important');
      container.style.setProperty('z-index', '9999', 'important');

      container.style.setProperty('box-sizing', 'border-box', 'important');
      container.style.setProperty('margin', '0', 'important');

      // Also force styles on the inner datepicker
      const datePicker = container.querySelector('.bs-datepicker') as HTMLElement;
      if (datePicker) {
        datePicker.style.setProperty('position', 'relative', 'important');
        datePicker.style.setProperty('transform', 'none', 'important');
        datePicker.style.setProperty('top', 'auto', 'important');
        datePicker.style.setProperty('left', 'auto', 'important');
        datePicker.style.setProperty('width', '100%', 'important');
        datePicker.style.setProperty('max-width', '350px', 'important');
        datePicker.style.setProperty('max-height', '85vh', 'important');
      }

      // Monitor for any changes and reapply styles
      const observer = new MutationObserver(() => {
        if (window.innerWidth <= 767 && container.isConnected) {
          this.forceMobileStyles(container);
        }
      });

      observer.observe(container, { attributes: true, attributeFilter: ['style'] });

      // Clean up observer when datepicker is closed
      setTimeout(() => {
        observer.disconnect();
      }, 10000); // Cleanup after 10 seconds max
    }
  }

  // More aggressive approach to force mobile styles
  private forceMobileStylesAggressively(): void {
    if (window.innerWidth <= 767) {
      const containers = document.querySelectorAll('.bs-datepicker-container');
      containers.forEach(container => {
        const element = container as HTMLElement;

        // Remove any existing transform or positioning
        element.style.removeProperty('transform');
        element.style.removeProperty('will-change');

        // Apply mobile styles with highest priority
        const mobileStyles = `
          position: fixed !important;
          top: 0px !important;
          left: 0px !important;
          right: 0px !important;
          bottom: 0px !important;
          width: max-content !important;
          height: max-content !important;
          transform: none !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 9999 !important;
          box-sizing: border-box !important;
          margin: 0 !important;
        `;

        element.setAttribute('style', mobileStyles);

        // Also apply to inner datepicker
        const datePicker = element.querySelector('.bs-datepicker') as HTMLElement;
        if (datePicker) {
          const innerStyles = `
            position: relative !important;
            transform: none !important;
            top: auto !important;
            left: auto !important;
            width: 100% !important;
            max-width: 350px !important;
            max-height: 85vh !important;
            background: #fff !important;
            border-radius: 8px !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5) !important;
            overflow: hidden !important;
            border: none !important;
            margin: 0 !important;
          `;
          datePicker.setAttribute('style', datePicker.getAttribute('style') + '; ' + innerStyles);
        }
      });

      // Keep checking and reapplying styles
      let attempts = 0;
      const intervalId = setInterval(() => {
        attempts++;
        if (attempts > 20) { // Stop after 2 seconds (20 * 100ms)
          clearInterval(intervalId);
          return;
        }

        const containers = document.querySelectorAll('.bs-datepicker-container');
        containers.forEach(container => {
          const element = container as HTMLElement;
          if (element.style.transform && element.style.transform !== 'none') {
            this.forceMobileStylesAggressively();
          }
        });
      }, 100);
    }
  }

  // Close date picker method
  closeDatePicker(): void {
    // Remove body class for mobile scroll prevention
    document.body.classList.remove('datepicker-open');

    if (this.journeyType === JourneyType.ROUND_TRIP && this.dateRangePicker) {
      this.dateRangePicker.hide();
    } else if (this.singleDatePicker) {
      this.singleDatePicker.hide();
    }
  }

  get parentFormGroupForDestinationInfo(): FormGroup {
    return (this.flightForm.get('OriginDestinationInfo') as FormArray).at(0) as FormGroup;
  }

  get selectedOrigin(): string | null {
    return this.parentFormGroupForDestinationInfo?.get('airportOriginCode')?.value || null;
  }

  get selectedDestination(): string | null {
    return this.parentFormGroupForDestinationInfo?.get('airportDestinationCode')?.value || null;
  }

  onSearch() {
    this.getLocalStorageValues();
    if (this.flightForm.invalid) {
      this.flightForm.markAllAsTouched();
      const errors = this.flightForm.errors;
      console.log('Form is invalid', errors);
      return;
    }
    // Snapshot plain, serializable form value and persist only when user clicks Search
    const raw = this.flightForm.getRawValue();
    const snapshot = JSON.parse(JSON.stringify(raw));

    // Persist to localStorage and update
          console.log("snapshot"+JSON.stringify(raw));

    if(snapshot?.journeyType){
      console.log("snapshot"+snapshot);
    localStorage.setItem('flightSearchRequest', JSON.stringify(snapshot));
    this.searchBarService.changeFlightSearchRequest(snapshot as FlightSearchRequest);
    }

    // Trigger API immediately if we're already on flight-list (no navigation)
    if (this.isAllowedFlightSearchUrl) {
      this.searchBarService.getFlightSearchData();
    }

    const queryString = this.searchBarService.toQueryString(snapshot);
    this.search.emit(queryString);
  }

  get journeyType() {
    return this.flightForm.get('journeyType')?.value as JourneyType;
  }

  get totalGuestCount(): number {
    const guestCount = this.flightForm?.value;
    return guestCount ? parseInt(guestCount.adults) + parseInt(guestCount.childs) + parseInt(guestCount.infants) : 0;
  }

  get guestDesc(): string {
  const guestCount = this.flightForm?.value;
  const flightType = this.flightForm.get('class')?.value;
  if (!guestCount) return '';
  const aSuffix = guestCount.adults > 1 ? 's' : '';
  const cSuffix = guestCount.childs > 1 ? 'ren' : '';
  const iSuffix = guestCount.infants > 1 ? 's' : '';
  const adults = guestCount.adults > 0 ? `${guestCount.adults} Adult${aSuffix}` : '';
  const children = guestCount.childs > 0 ? `${guestCount.childs} Child${cSuffix}` : '';
  const infants = guestCount.infants > 0 ? `${guestCount.infants} Infant${iSuffix}` : '';
    const flightClass = this.getSelectedFlightClass(flightType);
    return [adults, children, infants, flightClass].filter(Boolean).join(', ');
  }

  private getSelectedFlightClass(flightClass: FlightType): string {
    switch (flightClass) {
      case FlightType.FIRST_CLASS:
        return 'First Class';
      case FlightType.BUSINESS:
        return 'Business';
      case FlightType.PREMIUM_ECONOMY:
        return 'Premium Economy';
      case FlightType.ECONOMY:
      default:
        return 'Economy';
    }
  }

  private get isAllowedFlightSearchUrl(): boolean {
    const url = this.router.url.replace(/^\//, ''); // Remove leading slash if present
    return this.allowedFlightSearchURLs.some(allowed => url.includes(allowed));
  }

  getDepartureMinDate(): Date {
    const journeyType = this.flightForm.get('journeyType')?.value;
    if (journeyType !== JourneyType.ROUND_TRIP) {
      // If not round trip, return current date
      return new Date();
    }
    const departureDateValue = this.parentFormGroupForDestinationInfo.get('departureDate')?.value;
    if (!departureDateValue) return new Date();

    let departureDate: Date;
    if (typeof departureDateValue === 'string') {
      const parsedDate = this.parseJsonDate(departureDateValue);
      departureDate = parsedDate || new Date(departureDateValue);
    } else {
      departureDate = new Date(departureDateValue);
    }

    // Return date must be at least one day after departure
    const minReturnDate = new Date(departureDate);
    minReturnDate.setDate(departureDate.getDate() + 1);
    return minReturnDate;
  }

  // Custom validator to check if returnDate > departureDate
  returnDateAfterDepartureValidator(group: AbstractControl): ValidationErrors | null {
    // Only validate return vs departure when journey type is ROUND_TRIP
    const journey = this.flightForm?.get('journeyType')?.value as JourneyType | undefined;
    if (journey !== JourneyType.ROUND_TRIP) return null;
    const departure = group.get('departureDate')?.value;
    const ret = group.get('returnDate')?.value;
    if (departure && ret) {
      let depDate: Date;
      let retDate: Date;

      // Parse departure date
      if (typeof departure === 'string') {
        const parsedDep = this.parseJsonDate ? this.parseJsonDate(departure) : new Date(departure);
        depDate = parsedDep || new Date(departure);
      } else {
        depDate = new Date(departure);
      }

      // Parse return date
      if (typeof ret === 'string') {
        const parsedRet = this.parseJsonDate ? this.parseJsonDate(ret) : new Date(ret);
        retDate = parsedRet || new Date(ret);
      } else {
        retDate = new Date(ret);
      }

      if (retDate <= depDate) {
        return { returnDateBeforeDeparture: true };
      }
    }
    return null;
  }

  onDateChange(event: any, controlName: string) {
    this.parentFormGroupForDestinationInfo.get(controlName)?.patchValue(event);
    this.flightForm.updateValueAndValidity();
    this._cdr.detectChanges(); // Ensure the view updates
  }


  get isInValid(): boolean {
    return this.flightForm.invalid || this.flightForm.disabled;
  }

ngOnDestroy(): void {
  document.body.classList.remove('datepicker-open');
  this.unlockBodyScroll();
  this._autoSaveSub?.unsubscribe();
}

  private _autoSaveSub?: Subscription;
  private _suppressAutoSave: boolean = false;

}


